import Vue from 'vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import App from './App'
import Config from './config'

const routes = {
    '/': App,
    '/config': Config
}

Vue.config.productionTip = false;

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: { currentRoute: window.location.pathname },
  computed: {
    ViewComponent() {
      return routes[this.currentRoute] || App
    }
  },
  render(h) {
    return h(this.ViewComponent)
  }
});
